import React from 'react'

export default function Footer() {
  return (
    <div className='footer'>
         <div className='flexRow'>
            <p className='spacers'><a href="https://www.facebook.com/groups/2960960940872766" title="Facebook Event Page" rel="noreferrer" target="_blank">Facebook Event Page</a></p>
            <p className='spacers'><a  href="http://radiobarspokane.com" title="Official Radio Bar Website" rel="noreferrer" target="_blank">Radio Bar's Website</a></p>
            <p className='spacers'><a href="http://ericpolley.com" title="Event Host" rel="noreferrer" target="_blank">Event Host Official Website</a></p>
        </div>
        <div className='flexCol'>
        <p>This website was updated on November.8.2022</p>
      </div>
    </div>
  )
}
